import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { tap } from 'rxjs/operators';
import { Utils } from './utils.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
    private utils: Utils) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authService.getLoggedUserDetails();
    if (currentUser) {
      if (request.body && request.body.hasOwnProperty('enableCors')) {
        request = request.clone({
          withCredentials: false
        });
      } else {
        request = request.clone({
          setHeaders: {
            Accept: '*/*'
          },
          withCredentials: true
        });
      }

      // request = request.clone({
      //   withCredentials: true
      // });
    }

    return next.handle(request);
  }
}
